// © Microsoft Corporation. All rights reserved.

import { PageBase } from "@msnews/experiences-redux";
import { RequestContext } from "@msnews/core";

// export default function bootstrapPrimeHybrid(): void {
// Get an instance of the PageBase for this app, and start the app
const app = PageBase.getInstance();

const requestContext = new RequestContext();

// Start the App
app.start();
